export default __webpack_public_path__ + "f9c6977bde31b38d66bcb873ea8fb7e1.png";